import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLoad } from "../../context/Load";
import ApiServices from "../../services/apiServices";
import Menu from "../../Components/Menu";
import voltar from "../../assets/images/png/voltar.png";
import smileUser from "../../assets/images/svg/smileUser.svg";
import smileFeliz from "../../assets/images/svg/smileFeliz.svg";
import "./index.css";

// Importações do Swiper
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function RankingLibertadores() {
  const { setLoad } = useLoad();
  const navigate = useNavigate();

  // Estados principais
  const [listaRanking, setListaRanking] = useState([]);
  const [resumo, setResumo] = useState(null);
  const [modal, setModal] = useState({});
  const [botaoSelecionado, setBotaoSelecionado] = useState(0);
  const [souEu, setSouEu] = useState([]);
  const [itensExibidos, setItensExibidos] = useState(5);
  const [carregandoRanking, setCarregandoRanking] = useState(false);
  const [mostrarBotaoSaoPaulo, setMostrarBotaoSaoPaulo] = useState(false);
  const [mostrarBotaoQuartasFinais, setMostrarBotaoQuartasFinais] =
    useState(false);

  // Constantes
  const [botaoLibertadores, setBotaoLibertadores] = useState([
    {
      id: "1",
      nome: "Liber. Final",
      selecionado: true,
    },
    {
      id: "2",
      nome: "Liber. São Paulo",
      selecionado: false,
    },
    {
      id: "3",
      nome: "4ªs de Final",
      selecionado: false,
    },
  ]);

  // Funções de API
  const buscarRanking = async (id) => {
    setListaRanking([]);
    setSouEu([]);
    try {
      setCarregandoRanking(true);
      if (id == 1) {
        const response = await ApiServices.apiGet(
          `importacao/campanha-libertadores/ranking`
        );
        setListaRanking(response.data);
        const meuItem = response.data.find((item) => item?.souEu == true);
        setSouEu(meuItem ? [meuItem] : []);
      } else if (id == 2) {
        const response = await ApiServices.apiGet(
          `importacao/campanha-libertadores/ranking?filtro=sp`
        );
        setListaRanking(response.data);
        const meuItem = response.data.find((item) => item?.souEu == true);
        setSouEu(meuItem ? [meuItem] : []);
      } else if (id == 3) {
        const response = await ApiServices.apiGet(
          `importacao/campanha-libertadores/ranking?grupo=Z`
        );
        setListaRanking(response.data);
        const meuItem = response.data.find((item) => item?.souEu == true);
        setSouEu(meuItem ? [meuItem] : []);
      }
    } catch (err) {
      console.error("Erro ao buscar ranking:", err);
    } finally {
      setCarregandoRanking(false);
    }
  };
  const buscarRankingSaoPaulo = async () => {
    setListaRanking([]);
    setSouEu([]);
    try {
      setCarregandoRanking(true);

      const response = await ApiServices.apiGet(
        `importacao/campanha-libertadores/ranking?filtro=sp`
      );

      const meuItem = response.data.find((item) => item?.souEu == true);

      // setMostrarBotaoSaoPaulo(!!meuItem);
    } catch (err) {
      console.error("Erro ao buscar ranking:", err);
    } finally {
      setCarregandoRanking(false);
    }
  };

  const buscarRankingQuartasFinais = async () => {
    setListaRanking([]);
    setSouEu([]);
    try {
      setCarregandoRanking(true);

      const response = await ApiServices.apiGet(
        `importacao/campanha-libertadores/ranking?grupo=Z`
      );

      const meuItem = response.data.find((item) => item?.souEu == true);

      setMostrarBotaoQuartasFinais(!!meuItem);
    } catch (err) {
      console.error("Erro ao buscar ranking:", err);
    } finally {
      setCarregandoRanking(false);
    }
  };

  // Função para carregar mais itens
  const carregarMaisItens = () => {
    setItensExibidos((prev) => prev + 5);
  };

  // Função para renderizar avatar
  const renderizarAvatar = (item) => {
    if (item?.participanteUrlAvatar) {
      return (
        <img
          className="avatar-img"
          src={item.participanteUrlAvatar}
          alt="Avatar"
        />
      );
    }
    return (
      <img
        className="avatar-img"
        src={item?.souEu ? smileFeliz : smileUser}
        alt="Avatar padrão"
      />
    );
  };

  // Função para renderizar posição
  const renderizarPosicao = (posicao) => {
    return <div className="posicao-numero">{posicao || "-"}°</div>;
  };

  // Obter itens visíveis baseado no estado itensExibidos
  const itensVisiveis = (listaRanking || []).slice(0, itensExibidos);
  const temMaisItens = (listaRanking || []).length > itensExibidos;

  useEffect(() => {
    const botaoSelecionado = botaoLibertadores.find(
      (botao) => botao.selecionado === true
    )?.id;
    buscarRanking(botaoSelecionado);
  }, [botaoLibertadores]);
  useEffect(() => {
    buscarRankingSaoPaulo();
    buscarRankingQuartasFinais();
  }, []);
  return (
    <div className="w-100">
      <div className="imgBackground"></div>
      <Menu />

      {/* Cabeçalho */}
      <div className="px-3">
        <div
          className="position-relative"
          style={{ marginTop: 5, fontSize: 22, marginBottom: 20 }}
        >
          <div className="d-flex justify-content-center mt-3">
            <div
              className="d-flex justify-content-start w-100"
              style={{ maxWidth: 500, padding: "0 0 0 15px" }}
            >
              <Link to="/home">
                <img className="imgVoltarLogado" src={voltar} alt="Voltar" />
              </Link>
              <div className="tituloLogado" style={{ fontSize: 14 }}>
                Ranking Libertadores <br /> 2025
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>

      {/* Conteúdo principal */}
      <div className="d-flex justify-content-center flex-column align-items-center px-3">
        <div
          className="d-flex flex-column align-items-center w-100"
          style={{ maxWidth: 500 }}
        >
          <div className="row w-100 d-flex justify-content-center">
            <div className="col-6 m-0 p-0">
              {/* Botão Como Funciona */}
              <button
                className="btn-grupo w-100"
                onClick={() => navigate("/ranking-libertadores/como-funciona")}
              >
                Como funciona
              </button>
            </div>
          </div>

          {/* Botões de grupo */}
          <div className="botoes-grupo mt-2 d-flex justify-content-center p-3">
            <div className="col-4" title="Liberadores Final">
              <button
                className={`btn-grupo w-100 ${
                  botaoLibertadores[0].selecionado ? "ativo" : ""
                }`}
                onClick={() => {
                  setBotaoLibertadores([
                    { ...botaoLibertadores[0], selecionado: true },
                    { ...botaoLibertadores[1], selecionado: false },
                    { ...botaoLibertadores[2], selecionado: false },
                  ]);
                }}
                disabled={carregandoRanking}
              >
                {botaoLibertadores[0].nome}
              </button>
            </div>
            {mostrarBotaoSaoPaulo && (
              <div className="col-4" title="Liberadores São Paulo">
                <button
                  className={`btn-grupo w-100 ${
                    botaoLibertadores[1].selecionado ? "ativo" : ""
                  }`}
                  onClick={() => {
                    setBotaoLibertadores([
                      { ...botaoLibertadores[0], selecionado: false },
                      { ...botaoLibertadores[1], selecionado: true },
                      { ...botaoLibertadores[2], selecionado: false },
                    ]);
                  }}
                  disabled={carregandoRanking}
                >
                  {botaoLibertadores[1].nome}
                </button>
              </div>
            )}
            {mostrarBotaoQuartasFinais && (
              <div className="col-4" title="4ªs de Final">
                <button
                  className={`btn-grupo w-100 ${
                    botaoLibertadores[2].selecionado ? "ativo" : ""
                  }`}
                  onClick={() => {
                    setBotaoLibertadores([
                      { ...botaoLibertadores[0], selecionado: false },
                      { ...botaoLibertadores[1], selecionado: false },
                      { ...botaoLibertadores[2], selecionado: true },
                    ]);
                  }}
                  disabled={carregandoRanking}
                >
                  {botaoLibertadores[2].nome}
                </button>
              </div>
            )}
          </div>

          {/* Loading */}
          {carregandoRanking && (
            <div className="ranking-loading">
              <div className="loading-spinner"></div>
              <div className="loading-text">Carregando ranking...</div>
            </div>
          )}

          {/* Ranking do usuário */}
          {!carregandoRanking &&
            souEu.length > 0 &&
            souEu[0] &&
            souEu?.map(
              (item, index) =>
                item && (
                  <div
                    key={item.id || index}
                    className={`ranking-card mt-2 ${
                      item?.souEu ? "ranking-eu" : ""
                    }`}
                  >
                    <div className="ranking-posicao">
                      {renderizarPosicao(item?.posicao)}
                    </div>

                    <div className="ranking-participante">
                      <div className="participante-avatar">
                        {renderizarAvatar(item)}
                      </div>
                      <div className="participante-info">
                        <div className="participante-nome">
                          {item.nome}
                          {item?.souEu && (
                            <span className="voce-indicator"> (Você)</span>
                          )}
                        </div>
                        <div className="participante-dealer">{item.dealer}</div>
                      </div>
                      <div className="participante-grupo">
                        <div className="grupo-label">Grupo</div>
                        <div className="grupo-valor">{item.grupo}</div>
                      </div>
                    </div>

                    <div className="ranking-pontos">
                      <div className="pontos-valor">
                        {item.pontos?.toLocaleString("pt-br", {
                          minimumFractionDigits: 2,
                        })}
                      </div>
                      <div className="pontos-label">pts</div>
                    </div>
                  </div>
                )
            )}
          <div className="mt-2"></div>
          {/* Lista de ranking */}
          {!carregandoRanking &&
            itensVisiveis.map(
              (item, index) =>
                item && (
                  <div
                    key={item.id || index}
                    className={`ranking-card  ${
                      item.souEu ? "ranking-eu" : ""
                    }`}
                  >
                    <div className="ranking-posicao">
                      {renderizarPosicao(item?.posicao)}
                    </div>

                    <div className="ranking-participante">
                      <div className="participante-avatar">
                        {renderizarAvatar(item)}
                      </div>
                      <div className="participante-info">
                        <div className="participante-nome">
                          {item.nome}
                          {item.souEu && (
                            <span className="voce-indicator"> (Você)</span>
                          )}
                        </div>
                        <div className="participante-dealer">{item.dealer}</div>
                      </div>
                      {botaoLibertadores[0].selecionado == true ? (
                        <div className="participante-grupo">
                          <div className="grupo-label">Grupo</div>
                          <div className="grupo-valor">{item.grupo}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="ranking-pontos">
                      <div className="pontos-valor">
                        {item.pontos?.toLocaleString("pt-br", {
                          minimumFractionDigits: 2,
                        })}
                      </div>
                      <div className="pontos-label">pts</div>
                    </div>
                  </div>
                )
            )}

          {/* Botão ver mais */}
          {!carregandoRanking && temMaisItens && (
            <div className="btn-ver-mais-container">
              <button
                className="btn-ver-mais"
                onClick={carregarMaisItens}
                disabled={carregandoRanking}
              >
                {carregandoRanking ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    >
                      <span className="visually-hidden">Carregando...</span>
                    </span>
                    Carregando...
                  </>
                ) : (
                  "Ver mais"
                )}
              </button>
            </div>
          )}

          {/* Indicador de fim da lista */}
          {!carregandoRanking && !temMaisItens && listaRanking.length > 0 && (
            <div className="fim-lista-indicator">
              <div className="text-muted">
                Todos os {listaRanking.length || 0} participantes carregados
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
